export { stripeAdapter, stripeAdapterClient } from '../../payments/adapters/stripe/index.js'
